const Button = ({ 
  children, 
  variant = "primary", 
  size = "md", 
  className = "", 
  ...props 
}) => {
  const baseClasses = "font-medium transition-colors rounded-md inline-flex items-center gap-2"
  
  const variants = {
    primary: "bg-gradient-primary hover:opacity-90 text-primary-foreground shadow-strong",
    secondary: "border border-primary text-primary hover:bg-primary hover:text-white",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    outline: "border-2 border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-800 hover:border-gray-400"
  }
  
  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg"
  }
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button